export const CONTENT_WINDOWS = {
    COUPONS: 'coupons',
    REWARDS: 'rewards',
    OVERVIEW: 'overview',
}
